import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { Field, reduxForm } from 'redux-form'
import * as components from '../../components'
import {
  FormButtons,
  renderers,
  titleCaseByUnderscore,
  validations,
} from '../../components'
import { OrganizationDisplay } from './OrganizationDisplay'

const USER_RIGHTS_TYPES = [
  'repair_inventory',
  'loaner_inventory',
  'non_serialized_inventory',
  'tickets',
  'customer_report_download',
  'delivery_report_download',
  'loaner_record_report_download',
  'non_serialized_order_line_report_download',
  'order_line_report_download',
  'status_report_download',
  'token_report_download',
   'voucher_report_download'
]

const asyncValidate = async (values, dispatch, props, fieldString) => {
  if (!fieldString) {
    let rightExists = false
    USER_RIGHTS_TYPES.forEach((right) => {
      if (values[right]) {
        rightExists = true
      }
    })
    if (!rightExists) {
      try {
        throw new Error(
          'Please select at least one type of rights from the list',
        )
      } catch (e) {
        // eslint-disable-next-line no-throw-literal
        throw {
          _error: 'Please select at least one type of rights from the list',
        }
      }
    }
  }
}
const UserDisplay = (props) => {
  return (
    <>
      <Field
        label="User"
        name="user"
        component={renderers.renderHiddenField}
        type="text"
      />
      <Field
        label="User"
        name="user_suggestions"
        actualFieldName="user"
        endpoint="users"
        renderSuggestion={(user) => {
          return (
            <ReactBootstrap.Col>
              <h6>{user.first_name + ' ' + user.last_name}</h6>
              <h6>{user.email}</h6>
            </ReactBootstrap.Col>
          )
        }}
        validate={[validations.required]}
        component={renderers.EaseOnAutoSuggest}
        type="text"
      />
    </>
  )
}

let UserRightsForm = (props) => {
  const {
    enableUserSelection,
    handleSubmit,
    pristine,
    reset,
    submitting,
    disabled,
    error,
  } = props
  return (
    <form onSubmit={handleSubmit}>
      {error ? <components.ErrorDisplay error={error} /> : ''}
      {enableUserSelection ? <UserDisplay /> : ''}
      <OrganizationDisplay />
      <ReactBootstrap.Col className="pt-1" xs="12">
        <ReactBootstrap.Table size="sm">
          <tbody>
            {USER_RIGHTS_TYPES.map((right) => {
              return (
                <tr>
                  <th>
                    <label htmlFor={right}>
                      {titleCaseByUnderscore(right)}
                    </label>
                  </th>
                  <td>
                    <Field
                      name={right}
                      id={right}
                      component="input"
                      type="checkbox"
                    />
                  </td>
                </tr>
              )
            })}
          </tbody>
        </ReactBootstrap.Table>
      </ReactBootstrap.Col>
      <FormButtons
        disabled={disabled}
        className="mt-3"
        submitting={submitting}
        pristine={pristine}
        reset={reset}
      />
    </form>
  )
}
UserRightsForm = reduxForm({
  form: 'user-rights-form',
  asyncValidate,
  asyncBlurFields: [],
  enableReinitialize: true,
})(UserRightsForm)
export default UserRightsForm
